import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

import "../../styles/resources.css";
import { BmsHeader } from "../../components/main-components/app.header";
import { useAuth } from "../../services/authentication/authentication.context";
import { getTutorialByField } from "../../services/documents/documents.context";
import { AppFooter } from "../../components/main-components/footer";
import { AppAlert } from "../../components/utilities/alert";
import { SuccessCard } from "../../components/cards/success-card";
import { Loader } from "../../components/utilities/loader";
import { TutorialList } from "../../components/utilities/tutorial-list";
import { QuestionUnit } from "../../components/tutorials/question-unit";





export const TutorialDetails = () => {

    const { isAuthenticated, userData } = useAuth();

    const chosenField = new URLSearchParams(window.location.search).get('field');
    const resultsRef = useRef();

    const bufferArray = Array(100).fill('');

   
    const [alertData, setAlertData] = useState();
    const [resAlert, setResAlert] = useState();
    const [multArray, setMultArray] = useState(bufferArray);
    const [ansViewd, setAnsViewed] = useState(false);
    const [MCQs, setMCQs] = useState([]);
    const [randTest, setRandTest] = useState();
    const [loading, setLoading] = useState(false);
    const [tutorials, setTutorials] = useState([]);
    const [viewList, setViewList] = useState(false);

    const getRandomInt = (n) => Math.floor(Math.random() * n);

    const navigateTo = useNavigate();





    const handleSubmit = () => {
        let sum = 0;
        if (!isAuthenticated) {
            setAlertData({
                caption: "Access denied!",
                message: "Please sign in to answer tutorial questions",
                accept: 'Sign in',
                reject: 'Cancel',
                acceptAction: () => navigateTo("/login"),
                rejectAction: () => setAlertData()
            });
            return;
        }
        multArray.forEach((answer, indx) => {
            if (Array.from(answer).join() === MCQs[indx]?.answer) {
                sum = sum + 1;
            }
        });

        setResAlert({
            max: MCQs?.length,
            score: sum
        })
    }

    const handleViewAnswers = () => {
        const answerMap = MCQs?.map((obj) => obj?.answer.split(","));
        setMultArray(answerMap);
        setResAlert();
    }



    useEffect(() => {
        const loadSomeTutorials = async (f) => {
            setLoading(true);
            const res = await getTutorialByField(f);
            setTutorials(res);
            const randExam = getRandomInt(res?.length)
            setLoading(false);
            return res[randExam];
        }
        (async () => {
            const data = await loadSomeTutorials(chosenField);
            if (!data) return;
            setMCQs(JSON.parse(data?.jsonText));

            setRandTest(data);
        })();
    }, [chosenField]);



    const handleAnswers = (questionIndex, answerOption) => {
        if (multArray[questionIndex].includes(answerOption)) {
            setMultArray(prevArray => {
                const newArray = [...prevArray]; // 1. Clone the array
                newArray[questionIndex] = newArray[questionIndex].filter((elem) => (
                    elem !== answerOption
                ));       // 2. Replace the element
                return newArray;                 // 3. Return the updated array
            });
            return;
        }
        setMultArray(prevArray => {
            const newArray = [...prevArray]; // 1. Clone the array
            newArray[questionIndex] = [...new Set([...newArray[questionIndex], answerOption])];       // 2. Replace the element
            return newArray;                 // 3. Return the updated array
        });
    }

    return (
        <div className="app-body">
            <BmsHeader />
            {loading && <Loader />}
            {alertData && (
                <AppAlert
                    caption={alertData.caption}
                    message={alertData.message}
                    accept={alertData.accept}
                    reject={alertData.reject}
                    acceptAction={alertData.acceptAction}
                    rejectAction={alertData.rejectAction}
                    close={() => setAlertData()}
                />
            )}
            {viewList && (
                <TutorialList
                    lisData={tutorials}
                    onClose={() => setViewList(false)}
                    setTutorialData={(v) => {
                        setMCQs(JSON.parse(v?.jsonText));
                        setRandTest(v);
                    }}
                />
            )}
            {MCQs?.length > 0 ?
                (<div className="questions-container">
                    <div className="questions-sub">

                        <div
                            className="opt-buttons"
                        >
                            {userData?.role === 'admin' &&
                                <button
                                    className="adm-add opt-q-button"
                                    onClick={() => navigateTo("/addtutorial")}
                                >
                                    <FontAwesomeIcon icon={faPlus} />
                                    <span>Create quiz</span>
                                </button>
                            }
                            <button
                                className="adm-add opt-q-button"
                                onClick={() => setViewList(true)}
                            >
                                <FontAwesomeIcon icon={faPlus} />
                                <span>Select tutorial</span>
                            </button>
                        </div>

                        <div className="questions-top-bar c-al flx-rw">
                            <div
                                className="course-title" ref={resultsRef}
                                style={{ scrollMarginTop: 100 }}
                            >
                                <span>{randTest?.title}</span>
                                &nbsp;
                                <span style={{ fontSize: 12, marginInlineStart: 16 }}>({MCQs?.length} MCQ questions)</span>
                            </div>
                            {ansViewd &&
                                <div
                                    className="opt-buttons"
                                    onClick={() => {
                                        setMultArray(bufferArray);
                                        setAnsViewed(false);
                                    }}
                                >
                                    <button className="opt-q-button">Retake quiz</button>
                                </div>
                            }
                        </div>

                        {resAlert && (
                            <SuccessCard
                                score={resAlert.score}
                                pased={resAlert.status}
                                max={resAlert.max}
                                viewAns={() => {
                                    handleViewAnswers();
                                    setAnsViewed(true);
                                }}
                                retake={() => {
                                    setMultArray(bufferArray);
                                    setAnsViewed(false);
                                    setResAlert();
                                }}
                            />
                        )}
                        {MCQs?.map((questionObj, indx) => {

                            const answerArr = Object.values(questionObj.answers);
                            const optionArr = Object.keys(questionObj.answers);

                            return (
                                <QuestionUnit
                                    multArray={multArray}
                                    indx={indx}
                                    ansViewd={ansViewd}
                                    questionObj={questionObj}
                                    optionArr={optionArr}
                                    answerQuestion={(p, q) => handleAnswers(p, q)}
                                    answerArr={answerArr}
                                />
                            )
                        })}
                        <button
                            className={classNames(
                                "tutorial-submit",
                                { 'disabled-btn': ansViewd }
                            )}
                            onClick={() => {
                                resultsRef.current?.scrollIntoView({
                                    behavior: 'smooth' // Smooth scrolling animation
                                });
                                handleSubmit();
                            }}
                            disabled={ansViewd}
                        >
                            Submit
                        </button>
                    </div>
                </div>) : (
                    <div className="questions-sub">

                        <div
                            className="opt-buttons"
                        >
                            {
                                userData?.role === 'admin' &&
                                <button
                                    className="adm-add opt-q-button"
                                    onClick={() => navigateTo("/addtutorial")}
                                >
                                    <FontAwesomeIcon icon={faPlus} />
                                    <span>Create quiz</span>
                                </button>
                            }
                        </div>

                        <div className="no-content">NO TUTORIAL QUIZES IN THIS CATEGORY FOR NOW</div>
                    </div>

                )}
            <AppFooter />
        </div>
    );
}